<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <ValidationObserver v-slot="{ handleSubmit }">
        <form @submit.prevent="handleSubmit(submit)">
          <md-card>
            <md-card-header class="md-card-header-text md-card-header-green">
              <div class="card-text">
                <h4 class="title">{{ formTitle }}</h4>
              </div>
            </md-card-header>
            <!--            <div class="edit-btn-container">-->
            <!--              <a-->
            <!--                data-toggle="dropdown"-->
            <!--                class="edit-btn"-->
            <!--                @click="enableModeEdit()"-->
            <!--              >-->
            <!--                <i class="fa fa-pen fa-2x"> </i>-->
            <!--                <p class="content-button">{{ $t("common.edit") }}</p>-->
            <!--              </a>-->
            <!--            </div>-->
            <md-card-content>
              <div class="md-layout text-center">
                <div class="md-layout-item md-size-100 md-xsmall-size-100">
                  <div class="md-layout">
                    <!-- Fields -->
                    <div
                      class="md-layout-item md-size-50 md-xsmall-size-100"
                      :class="{ 'md-size-100': item.type === 'ckeditor' }"
                      v-for="item in editForm"
                      :key="item.name"
                    >
                      <div class="md-layout">
                        <label
                          class="md-layout-item md-xsmall-size-100  md-form-label"
                          :class="[
                            { 'required-field': item.required },
                            { 'md-size-10': item.type === 'ckeditor' },
                            { 'md-size-20': item.type !== 'ckeditor' }
                          ]"
                          :for="item.name"
                        >
                          {{ item.label }}
                        </label>
                        <div class="md-layout-item md-xsmall-size-100">
                          <ValidationProvider
                            :name="item.label"
                            :rules="item.validateRule"
                            v-slot="{ passed, failed, errors }"
                          >
                            <md-field
                              :class="[
                                { 'md-error': failed },
                                { 'md-valid': passed }
                              ]"
                            >
                              <!--  Datepicker -->
                              <md-datepicker
                                v-if="item.type === 'date'"
                                v-model="item.value"
                                :disabled="item.disabled"
                                md-immediately
                              >
                              </md-datepicker>

                              <!--  Textarea -->
                              <md-textarea
                                v-else-if="item.type === 'textarea'"
                                v-model="item.value"
                                :data-vv-name="item.name"
                              >
                              </md-textarea>

                              <!--  Select -->
                              <md-select
                                v-else-if="item.type === 'select'"
                                v-model="item.value"
                                :name="item.name"
                                :id="item.name"
                                :disabled="item.disabled"
                              >
                                <md-option :value="''">{{
                                  $t("common.all")
                                }}</md-option>
                                <md-option
                                  :value="option.id"
                                  v-for="option in item.options"
                                  :key="option.id"
                                  >{{ option.name }}
                                </md-option>
                              </md-select>

                              <!--  Autocomplete -->
                              <md-autocomplete
                                v-else-if="item.type === 'autocomplete'"
                                v-model="item.value"
                                :disabled="item.disabled"
                                :md-options="autoOptions"
                                @md-changed="getOptions"
                                @md-opened="getOptions"
                                :auto-path="genAutoPath(item.path)"
                              >
                                <template
                                  slot="md-autocomplete-item"
                                  slot-scope="{ item, term }"
                                >
                                  <md-highlight-text :md-term="term"
                                    >{{ item }} {{ term }}
                                  </md-highlight-text>
                                </template>
                                <template
                                  slot="md-autocomplete-empty"
                                  slot-scope="{ term }"
                                >
                                  "{{ term }}" not found!
                                </template>
                                <div class="md-helper-text" v-if="item.value">
                                  <strong>Item:</strong>{{ item.name }} ({{
                                    item.value
                                  }})
                                </div>
                              </md-autocomplete>

                              <!--  Select2 -->
                              <div
                                class="form-select2-container"
                                v-else-if="item.type === 'select2'"
                              >
                                <select2
                                  v-model="item.value"
                                  id="ward-selection"
                                  :name="item.name"
                                  :disabled="item.disabled"
                                  :options="item.options"
                                  :settings="{
                                    dropdownAutoWidth: true,
                                    width: 'inherit'
                                  }"
                                />
                              </div>

                              <!--  Ckeditor -->
                              <div
                                v-else-if="item.type === 'ckeditor'"
                                style="width: 100%"
                              >
                                <ckeditor
                                  @ready="onReady"
                                  class="ckeditor-element"
                                  :editor="editor"
                                  v-model="item.value"
                                  :config="editorConfig"
                                ></ckeditor>
                              </div>

                              <!--  File -->
                              <md-file
                                v-else-if="item.type === 'file'"
                                :accept="item.accept"
                                v-model="item.file"
                                @md-change="changeFile(item, $event)"
                              >
                              </md-file>

                              <!--  Input -->
                              <md-input
                                v-else
                                v-model="item.value"
                                :data-vv-name="item.name"
                                :type="item.type"
                                :disabled="item.disabled"
                              >
                              </md-input>

                              <slide-y-down-transition>
                                <md-icon class="error" v-show="failed"
                                  >close</md-icon
                                >
                              </slide-y-down-transition>
                              <slide-y-down-transition>
                                <md-icon class="success" v-show="passed"
                                  >done</md-icon
                                >
                              </slide-y-down-transition>
                            </md-field>
                            <div class="validate-error">{{ errors[0] }}</div>
                          </ValidationProvider>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </md-card-content>

            <md-card-actions class="text-center">
              <md-button type="submit" class="md-success"
                >{{ $t("common.save") }}
              </md-button>
              <md-button native-type="button" @click="cancel"
                >{{ $t("common.cancel") }}
              </md-button>
            </md-card-actions>
          </md-card>
        </form>
      </ValidationObserver>
    </div>
  </div>
</template>

<script>
import queryHelper from "@/helpers/query-helper";
import _ from "lodash";
import { Http } from "../../services/http.init";
import DecoupledEditor from "@ckeditor/ckeditor5-build-decoupled-document";
import CkeditorUploadAdapter from "@/helpers/ckeditor-upload-adapter";
export default {
  name: "BaseEditForm",
  props: ["editForm", "formTitle"],
  data() {
    return {
      autoOptions: [],
      autoPath: "/",
      editor: DecoupledEditor,
      editorConfig: {
        fontSize: {
          options: [
            8,
            9,
            10,
            11,
            12,
            13,
            "default",
            15,
            16,
            17,
            18,
            19,
            20,
            21,
            22,
            24,
            26,
            28,
            36,
            48
          ],
          supportAllValues: true
        },
        extraPlugins: [this.uploader],
        language: "vi"
      }
    };
  },
  mounted() {},
  methods: {
    // enableModeEdit() {
    //   this.isEditMode = !this.isEditMode;
    // },
    onReady(editor) {
      // Insert the toolbar before the editable area.
      editor.ui
        .getEditableElement()
        .parentElement.insertBefore(
          editor.ui.view.toolbar.element,
          editor.ui.getEditableElement()
        );
    },
    cancel() {
      // this.isEditMode = false;
      this.$emit("cancel");
    },
    submit() {
      // this.isEditMode = false;
      let params = queryHelper.buildQuery(this.editForm);
      this.$emit("submitForm", params);
    },
    fetchOptions: _.debounce(async function(term) {
      let form = [
        {
          name: "name__~",
          value: term
        }
      ];
      new Http({ auth: true })
        .get(this.autoPath, { yql: queryHelper.buildQuery(form) })
        .then(response => {
          let options = [];
          response.data.data.forEach(value => {
            options.push(value.name);
          });
          this.autoOptions = options;
        });
    }, 500),
    getOptions(term) {
      this.fetchOptions(term);
    },
    genAutoPath: function(path) {
      this.autoPath = path;
    },
    uploader(editor) {
      editor.plugins.get("FileRepository").createUploadAdapter = loader => {
        return new CkeditorUploadAdapter(loader);
      };
    },
    changeFile(item, files) {
      if (files) {
        this.$emit("changeFile", item.name, files);
      }
    }
  }
};
</script>

<style scoped lang="scss">
.md-card .md-card-actions {
  border: none;
}

.text-center {
  justify-content: center !important;
}

.md-field .success.md-icon,
.md-field .error.md-icon {
  right: -20px;
}

.content-button {
  margin: 0;
}

.edit-btn-container {
  text-align: right;
  margin: 10px 40px;
}

.edit-btn-container a {
  display: inline-block;
  text-align: center;
}

.edit-btn-container a:hover {
  cursor: pointer;
}

.edit-btn-container a i {
  padding: 10px;
  background: #9c27b0;
  border-radius: 10px;
}

.edit-btn-container a i.fa-pen:before {
  color: #ffffff;
}
</style>
